export default __webpack_public_path__ + "static/media/tata-tea.6578082e.png";